import useNativeListener from './useNativeListener';

type PushType = 'NOTICE' | 'EVENT' | 'COUPON' | 'URL';

type AppState = 'FOREGROUND' | 'BACKGROUND';

interface PushMessage {
    pushType?: PushType,
    pushArg?: string,
    appState: AppState;
}

interface Props {
    onPushMessageReceived?: (data: PushMessage)=> void;
    deps?: any[];
}

function useOnPushMessageReceived({ onPushMessageReceived, deps }:Props) {
    useNativeListener('onPushMessageReceive', (data: PushMessage) => {
        console.log({ message: 'push message received', data });
        onPushMessageReceived?.(data);
    }, deps);
}

export default useOnPushMessageReceived;
